import React, { useEffect, useState } from "react";
import ImageGrid from "./ImageGrid";
import ImageList from "./ImageList";
import "../../../../assets/css/image-management.css";
import "../../../../assets/css/image-management-listing.css";
import MasterFilter from "./MasterFilter";
import BottomControls from "./BottomControls";
import { useDispatch } from "react-redux";
import imageActions from "../../../images/actions";
import ImageCaptionEditModal from "./ImageCaptionEditModal";
import Portal from "../Portal";
import { useClipboard } from "./ImageClipboardProvider";
import qs from "query-string";
import { useLocation, useParams } from "react-router-dom/cjs/react-router-dom";
import { showAlert } from "../../../../config/utils";

const ImageMain = props => {
    const dispatch = useDispatch();
    const { clip, copy, clear } = useClipboard();
    const { search } = useLocation();
    const { id, section } = useParams();
    const clientId = qs.parse(search)?.c_id ?? "";
    const [state, setState] = useState({
        isGridView: true,
        selectedImages: [],
        exportImageZipLoader: false
    });

    useEffect(() => {
        setState(prevState => ({ ...prevState, selectedImages: [] }));
    }, [id]);

    useEffect(() => {
        setState(prevState => {
            const selectedImages = prevState.selectedImages.filter(selectedImage => props.imageList.some(image => image.id === selectedImage.id));
            return { ...prevState, selectedImages };
        });
    }, [props.imageList]);

    const setGridView = async bool => {
        setState({ ...state, isGridView: bool });
    };

    const handleMultiSelectImage = (img, isChecked) => {
        const { selectedImages } = state;
        setState({
            ...state,
            selectedImages: isChecked ? [...selectedImages, img] : selectedImages.filter(t => t.id !== img.id)
        });
    };

    const handleSelectAll = async e => {
        setState({ ...state, selectedImages: e.target.checked ? props.imageList : [] });
    };

    const handleClearAll = () => {
        setState({ ...state, selectedImages: [] });
    };

    const exportImagesZip = async () => {
        const { match, basicDetails } = props;
        const sectionCodeMap = {
            siteinfo: 2,
            buildinginfo: 1,
            assetInfo: 3
        };

        const section = match?.params?.section;
        let params = {};

        if (section === "recommendationsinfo") {
            params = {
                recom_code: basicDetails?.code,
                username: localStorage.getItem("user"),
                image_ids: selectedImages?.map(i => i?.master_image?.id),
                is_recom: true
            };
        } else {
            const sectionCode = sectionCodeMap[section];
            if (sectionCode) {
                params = {
                    section_code: sectionCode,
                    username: localStorage.getItem("user"),
                    image_ids: selectedImages?.map(i => i?.master_image?.id)
                };
            } else {
                console.error("Invalid section provided!");
                return;
            }
        }

        setState({ ...state, exportImageZipLoader: true });

        await dispatch(imageActions.exportImagesZip(params));

        setState({ ...state, exportImageZipLoader: false });
    };

    const hasClipboard = !!clip.sourceEntityId && clip.itemIds?.length > 0;
    const sameClient = clip.clientId && clip.clientId === clientId;

    const canPaste = hasClipboard && sameClient && !(clip.sourceEntityId === id && clip.clientId === clientId);

    const onCopyImage = () => {
        copy({
            clientId,
            sourceEntityId: id,
            entityType: section,
            itemIds: selectedImages
        });
    };

    const onPasteImage = async () => {
        if (!canPaste) return;
        try {
            let temp = [];
            clip.itemIds?.forEach(img => {
                let obj = { id: img.id, url: img?.is_edited ? img.s3_eimage_key : img.s3_image_key };
                temp.push(obj);
            });
            await props.handleAssignImages({ images: temp });
            clear();
        } catch (e) {
            showAlert(e.message || "Paste failed");
        }
    };

    const { isGridView, selectedImages, exportImageZipLoader } = state;

    const {
        imageList,
        imageParams,
        totalCount,
        fetchMoreImages,
        handleSelectImage,
        handleClickImage,
        handleLimitChange,
        hasCheckBox,
        isReportImage,
        checkIfNarrativeImageUsed,
        imagesNotUsedIds,
        hasMore,
        hasViewRecom = false,
        viewRecommendations,
        hasEdit = false,
        hasCaptionEdit = true,
        hasExport = false,
        handleEdit,
        handleDelete,
        hasDelete = false,
        updateImage,
        handleInputCaptionData,
        refreshImageList,
        isSurveyAssetImage = false,
        isMobileRecommendation = false,
        isMobileRegularRecom = false,
        hasCaptionOnly = false,
        isMobRecom = false,
        onBulkDelete,
        hasBulkDelete = false,
        showImageSort = false,
        sortFieldOptions = [],
        sortField = "",
        sortOrder = "desc",
        onSortFieldChange,
        onSortOrderChange,
        sortDisabled = false
    } = props;

    const [showImageModal, setShowImageModal] = useState(false);
    const onEditCaption = () => {
        setShowImageModal(true);
    };

    return (
        <>
            {showImageModal && (
                <Portal
                    body={
                        <ImageCaptionEditModal
                            section={props.match?.params?.section}
                            onClose={() => setShowImageModal(false)}
                            updateImage={updateImage}
                            selectedImages={selectedImages}
                            refreshImageList={refreshImageList}
                            handleClearAll={handleClearAll}
                            isSurveyAssetImage={isSurveyAssetImage}
                            isMobileRecommendation={isMobileRecommendation}
                            isMobRecom={isMobRecom}
                            isMobileRegularRecom={isMobileRegularRecom}
                        />
                    }
                    onCancel={() => setShowImageModal(false)}
                />
            )}

            <div className={`dtl-sec col-md-12 image-manage info-images p-0`} id="main">
                <div className="filtr-otr">
                    <div className="flt-area-new">
                        <MasterFilter
                            handleSelectAll={handleSelectAll}
                            handleClearAll={handleClearAll}
                            selectedImages={selectedImages}
                            setGridView={setGridView}
                            isGridView={isGridView}
                            allSelected={imageList?.length > 0 && selectedImages?.length === imageList?.length}
                            exportImagesZip={exportImagesZip}
                            exportImageZipLoader={exportImageZipLoader}
                            isAsset={props.isAsset}
                            onEditCaption={onEditCaption}
                            hasExport={hasExport}
                            hasEdit={hasEdit}
                            hasBulkDelete={hasBulkDelete}
                            onBulkDelete={onBulkDelete}
                            hasImageCopyPaste={isMobRecom}
                            onCopyImage={onCopyImage}
                            onPasteImage={onPasteImage}
                            canPaste={canPaste}
                            imageList={imageList}
                            showImageSort={showImageSort}
                            sortFieldOptions={sortFieldOptions}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            onSortFieldChange={onSortFieldChange}
                            onSortOrderChange={onSortOrderChange}
                            sortDisabled={sortDisabled}
                        />
                    </div>
                </div>
                {isGridView ? (
                    <div className={"image-sec"}>
                        <ImageGrid
                            imageData={imageList}
                            handleSelect={handleSelectImage}
                            fetchMoreImages={fetchMoreImages}
                            handleClickImage={handleClickImage}
                            hasMore={hasMore}
                            hasCheckBox={hasCheckBox}
                            isReportImage={isReportImage}
                            checkIfNarrativeImageUsed={checkIfNarrativeImageUsed}
                            imagesNotUsedIds={imagesNotUsedIds}
                            hasViewRecom={hasViewRecom}
                            viewRecommendations={viewRecommendations}
                            hasEdit={hasEdit}
                            hasCaptionEdit={hasCaptionEdit}
                            hasExport={hasExport}
                            handleEdit={handleEdit}
                            updateImageFromInfoImages1={updateImage}
                            handleInputCaptionData={handleInputCaptionData}
                            handleDelete={handleDelete}
                            hasDelete={hasDelete}
                            handleMultiSelectImage={handleMultiSelectImage}
                            selectedImages={selectedImages}
                            isAsset={props.isAsset}
                            hasCaptionOnly={hasCaptionOnly}
                        />
                    </div>
                ) : (
                    <div className={"cnt-sec"}>
                        <ImageList
                            imageData={imageList}
                            handleSelect={handleSelectImage}
                            fetchMoreImages={fetchMoreImages}
                            handleClickImage={handleClickImage}
                            hasMore={hasMore}
                            hasCheckBox={hasCheckBox}
                            isReportImage={isReportImage}
                            checkIfNarrativeImageUsed={checkIfNarrativeImageUsed}
                            imagesNotUsedIds={imagesNotUsedIds}
                            hasViewRecom={hasViewRecom}
                            viewRecommendations={viewRecommendations}
                            hasEdit={hasEdit}
                            hasExport={hasExport}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            hasDelete={hasDelete}
                            updateImageFromInfoImages1={updateImage}
                            handleInputCaptionData={handleInputCaptionData}
                            handleMultiSelectImage={handleMultiSelectImage}
                            selectedImages={selectedImages}
                            isAsset={props.isAsset}
                            hasCaptionEdit={hasCaptionEdit}
                            hasCaptionOnly={hasCaptionOnly}
                        />
                    </div>
                )}
                <BottomControls
                    handleLimitChange={handleLimitChange}
                    loadedCount={imageList.length}
                    totalCount={totalCount}
                    limit={imageParams.limit}
                />
            </div>
        </>
    );
};

export default ImageMain;
